export default __webpack_public_path__ + "static/media/alipay.334aab07.svg";